// ---
import React from "react";
import { connect } from "react-redux";
import { change, FieldArray, formValueSelector, reduxForm } from "redux-form";
import { ff, form, Icon, Loader } from "@mc/mc-legacy";
import FileUploadApi from "../../api/gen/qsign/FileUploadApi";
import { Col, Row } from "@mc/ui-v3";
import { Button } from "reactstrap";
const Form = form.Form;
const FormBody = form.FormBody;
const FormActions = form.FormActions;

const validate = (formData) => {
  const errors = {};

  if (!formData.signPracovnikId) {
    errors.signPracovnikId = "Musí být vyplněn podepisující";
  }

  return errors;
};
/**
 * Formulář změny podepisujícího.
 */

class ChangeSignPersonForm extends React.Component {
  static formName = "changeSignPersonForm";
  constructor(props) {
    super(props);
  }

  componentWillUnmount() {
    const { files } = this.props;
    files && FileUploadApi.deleteDocuments(files.map((v) => v.uuid));
  }

  render() {
    const { onClose, handleSubmit, submitting, initialValues, pracovniciActive, pracovnici } = this.props;
    const { allSigners } = initialValues;
    const commons = {
      disabled: submitting,
    };

    const podepisujiciItemsAll = [];
    const podepisujiciItems = [];

    allSigners &&
      allSigners.forEach((item) => {
        const pr = {
          id: item.id,
          name: `${item.uplneJmeno} ${item.organizacniJednotka ? `(${item.organizacniJednotka.kod})` : ""}`,
          title: item.organizacniJednotka.nazev,
        };
        podepisujiciItemsAll.push(pr);
        if (typeof pracovniciActive[item.id] === "undefined" || !pracovniciActive[item.id]) {
          podepisujiciItems.push(pr);
        }
      });

    const renderPodepisujici = ({ fields }) => (
      <div>
        {fields.map((field, index) => {
          const signed = pracovnici && pracovniciActive[pracovnici[index]];
          return (
            <Row noGutters className="d-flex" xs="auto" key={index}>
              <Col>
                <ff.Autocomplete
                  name={`pracovnici[${index}]`}
                  items={signed ? podepisujiciItemsAll : podepisujiciItems}
                  useIdAsValue={true}
                  disabled={signed}
                  label="Podepisující"
                  renderItemContent={(item, name) => {
                    if (name && name.length > 0) {
                      return (
                        <span title={item.title ? item.title : ""} className="item-text">
                          {name}
                        </span>
                      );
                    } else {
                      return <span className="item-text">&nbsp;</span>;
                    }
                  }}
                />
              </Col>
              {index != 0 && !signed && (
                <Col className="d-flex justify-content-center px-1" xs="auto">
                  {" "}
                  <Button
                    className="d-flex  align-self-center mt-1 btn-transparent"
                    title="Odebrat Podepisujícího"
                    onClick={() => {
                      fields.remove(index),
                        change(ChangeSignPersonForm.formName, "pracovnici", pracovnici.splice(index));
                    }}
                  >
                    <Icon size="2x" icon={"trash-o"} />
                  </Button>
                </Col>
              )}
              {index + 1 == fields.length && (
                <Col className="d-flex justify-content-center" xs="auto">
                  <Button
                    className="d-flex  align-self-center mt-2 btn-transparent"
                    title="Přidat podepisujícího"
                    onClick={() => fields.push({})}
                  >
                    <Icon size="2x" icon={"plus-square-o"} />
                  </Button>
                </Col>
              )}
            </Row>
          );
        })}
      </div>
    );
    return (
      <Form onSubmit={handleSubmit}>
        <FormBody>
          {podepisujiciItems.length > 0 ? <FieldArray name="pracovnici" component={renderPodepisujici} /> : <Loader />}
        </FormBody>
        <FormActions onClose={onClose} disabled={submitting} submitButton="Změnit" cancelButton />
      </Form>
    );
  }
}

function mapStateToProps(state) {
  const selector = formValueSelector(ChangeSignPersonForm.formName);
  return { pracovnici: selector(state, "pracovnici") };
}

const reduxFormObj = reduxForm({
  form: ChangeSignPersonForm.formName,
  validate: validate,
})(ChangeSignPersonForm);
export default connect(mapStateToProps)(reduxFormObj);
